import { render } from "./TransactionsLV1.vue?vue&type=template&id=255c679d"
import script from "./TransactionsLV1.vue?vue&type=script&lang=js"
export * from "./TransactionsLV1.vue?vue&type=script&lang=js"

import "./TransactionsLV1.vue?vue&type=style&index=0&id=255c679d&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\lotus-Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__